const generateYesNoQuestions = () => [
    // Agriculture
    { text: "Do you enjoy spending time on farmlands?", categories: ["Agriculture"] },
    { text: "Are you interested in growing flowers or plants?", categories: ["Agriculture"] },
    { text: "Would you like to increase farm production through innovative methods?", categories: ["Agriculture"] },
    { text: "Are you curious about creating new farming technologies?", categories: ["Agriculture"] },
    { text: "Do you want to protect and study plant life?", categories: ["Agriculture"] },
    { text: "Are you interested in fisheries or aquatic life?", categories: ["Agriculture"] },
    { text: "Would you enjoy managing an agricultural business?", categories: ["Agriculture"] },
    { text: "Do you want to develop pest control solutions?", categories: ["Agriculture"] },
    { text: "Are you passionate about discovering new plant species?", categories: ["Agriculture"] },
    { text: "Would you like to work with rubber or organic farming?", categories: ["Agriculture"] },

    // Finance
    { text: "Are you good at managing family budgets?", categories: ["Finance"] },
    { text: "Do you find the stock market exciting?", categories: ["Finance"] },
    { text: "Are you analytical with numbers?", categories: ["Finance"] },
    { text: "Would you enjoy understanding how banks work?", categories: ["Finance"] },
    { text: "Are you interested in investment strategies?", categories: ["Finance"] },
    { text: "Do you have strong communication skills for financial roles?", categories: ["Finance"] },
    { text: "Would you like to manage a company's financial health?", categories: ["Finance"] },
    { text: "Are you curious about financial planning?", categories: ["Finance"] },
    { text: "Do you enjoy mathematical problem-solving?", categories: ["Finance"] },
    { text: "Would you like a secure job in the financial sector?", categories: ["Finance"] },

    // Technology
    { text: "Are you passionate about solving complex technical problems?", categories: ["Technology"] },
    { text: "Do you enjoy creating innovative solutions?", categories: ["Technology"] },
    { text: "Are you fascinated by nanotechnology?", categories: ["Technology"] },
    { text: "Would you like to develop communication technologies?", categories: ["Technology"] },
    { text: "Are you interested in automation and robotics?", categories: ["Technology"] },
    { text: "Do you enjoy designing electronic equipment?", categories: ["Technology"] },
    { text: "Would you like to explore nuclear technology?", categories: ["Technology"] },
    { text: "Are you curious about emerging technologies?", categories: ["Technology"] },
    { text: "Do you want to improve communication through technology?", categories: ["Technology"] },
    { text: "Would you enjoy developing military or navigation technologies?", categories: ["Technology"] },

    // Biology
    { text: "Are you passionate about protecting the environment?", categories: ["Biology"] },
    { text: "Do you want to develop medical solutions?", categories: ["Biology"] },
    { text: "Are you curious about animal life?", categories: ["Biology"] },
    { text: "Would you like to study marine ecosystems?", categories: ["Biology"] },
    { text: "Are you interested in developing vaccines?", categories: ["Biology"] },
    { text: "Do you want to explore life in the ocean?", categories: ["Biology"] },
    { text: "Would you enjoy studying microorganisms?", categories: ["Biology"] },
    { text: "Are you passionate about protecting endangered species?", categories: ["Biology"] },
    { text: "Do you want to create new medicines from plants?", categories: ["Biology"] },
    { text: "Would you like to understand the complexity of life?", categories: ["Biology"] },

    // Media ,"Entertainment"& Entertainment
    { text: "Do you have excellent writing skills?", categories: ["Media","Entertainment"] },
    { text: "Are you interested in revealing important stories?", categories: ["Media","Entertainment"] },
    { text: "Would you enjoy photography as a career?", categories: ["Media","Entertainment"] },
    { text: "Do you like creating digital content?", categories: ["Media","Entertainment"] },
    { text: "Are you passionate about film-making?", categories: ["Media","Entertainment"] },
    { text: "Would you enjoy being a radio or video jockey?", categories: ["Media","Entertainment"] },
    { text: "Do you love storytelling?", categories: ["Media","Entertainment"] },
    { text: "Are you interested in video editing?", categories: ["Media","Entertainment"] },
    { text: "Would you enjoy creating memes or digital content?", categories: ["Media","Entertainment"] },
    { text: "Do you have a unique communication style?", categories: ["Media","Entertainment"] }
];

export default generateYesNoQuestions;
